export const extractTopLevelDomain: (domain: string) => string = domain => {
  if (!domain || domain.length === 0) {
    throw new Error('Domain must be specified');
  }

  const segments: string[] = domain.split('.');

  if (segments.length < 2) {
    throw new Error(`Domain '${domain}' does hot have the right format.`);
  }

  /* Note:
   *  This approach does not take into the account domains like: ".co.uk"
   *  https://stackoverflow.com/questions/6449340/how-to-get-base-domain-from-the-url-in-javascript
   */
  const tld: string = segments.pop() as string;

  return tld;
};
